"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dealersReducer = exports.updateLocationSearchTermAction = exports.dealersSearchByLocationAction = exports.dealersSetDataAction = exports.dealersRequestDataByCodeAction = exports.dealersRequestDataByLatLngAction = exports.DEALERS_SET_LOCATION_SEARCH_TERM = exports.DEALERS_SEARCH_BY_LOCATION = exports.DEALERS_SET_DATA = exports.DEALERS_REQUEST_DATA_BY_CODE = exports.DEALERS_REQUEST_DATA_BY_LAT_LNG = void 0;
var dealers_model_1 = require("../models/dealers.model");
// Actions
exports.DEALERS_REQUEST_DATA_BY_LAT_LNG = 'DEALERS_REQUEST_DATA_BY_LAT_LNG';
exports.DEALERS_REQUEST_DATA_BY_CODE = 'DEALERS_REQUEST_DATA_BY_CODE';
exports.DEALERS_SET_DATA = 'DEALERS_SET_DATA';
exports.DEALERS_SEARCH_BY_LOCATION = 'DEALERS_SEARCH_BY_LOCATION';
exports.DEALERS_SET_LOCATION_SEARCH_TERM = 'DEALERS_SET_LOCATION_SEARCH_TERM';
// Action Dispatchers
var dealersRequestDataByLatLngAction = function (lat, lng, faultSource) { return function (dispatch) { return dispatch({
    type: exports.DEALERS_REQUEST_DATA_BY_LAT_LNG,
    payload: { lat: lat, lng: lng, faultSource: faultSource },
}); }; };
exports.dealersRequestDataByLatLngAction = dealersRequestDataByLatLngAction;
var dealersRequestDataByCodeAction = function (code) { return function (dispatch) { return dispatch({
    type: exports.DEALERS_REQUEST_DATA_BY_CODE,
    payload: { code: code },
}); }; };
exports.dealersRequestDataByCodeAction = dealersRequestDataByCodeAction;
var dealersSetDataAction = function (dealers) { return function (dispatch) { return dispatch({
    type: exports.DEALERS_SET_DATA,
    payload: dealers,
}); }; };
exports.dealersSetDataAction = dealersSetDataAction;
var dealersSearchByLocationAction = function (city, state) { return function (dispatch) { return dispatch({
    type: exports.DEALERS_SEARCH_BY_LOCATION,
    payload: { city: city, state: state },
}); }; };
exports.dealersSearchByLocationAction = dealersSearchByLocationAction;
var updateLocationSearchTermAction = function (term) { return function (dispatch) { return dispatch({
    type: exports.DEALERS_SET_LOCATION_SEARCH_TERM,
    payload: { term: term },
}); }; };
exports.updateLocationSearchTermAction = updateLocationSearchTermAction;
// Reducer
// eslint-disable-next-line default-param-last
var dealersReducer = function (state, action) {
    if (state === void 0) { state = (0, dealers_model_1.defaultDealersStateFactory)(); }
    switch (action.type) {
        case exports.DEALERS_REQUEST_DATA_BY_LAT_LNG:
            return __assign(__assign({}, state), { loading: true });
        case exports.DEALERS_REQUEST_DATA_BY_CODE:
            return __assign(__assign({}, state), { loading: true });
        case exports.DEALERS_SET_DATA:
            return __assign(__assign({}, state), { loading: false, dealers: __spreadArray([], action.payload, true) });
        case exports.DEALERS_SEARCH_BY_LOCATION:
            return __assign(__assign({}, state), { loading: true });
        case exports.DEALERS_SET_LOCATION_SEARCH_TERM:
            return __assign(__assign({}, state), { locationSearchTerm: action.payload.term });
        default: return state;
    }
};
exports.dealersReducer = dealersReducer;
exports.default = exports.dealersReducer;
